import { sample } from 'effector';
import { debounce } from 'patronum/debounce';
import { signout } from '@features/common';
import { typesApi } from '../../api';
import {
  fxGetList,
  searchChanged,
  $data,
  $isLoading,
  $search,
  getList,
} from './ticket-type-select.model';

fxGetList.use(typesApi.getTypesList);

sample({
  clock: getList,
  target: fxGetList,
});

const searchChangedDebounce = debounce({
  source: searchChanged,
  timeout: 250,
});

$search.on(searchChangedDebounce, (_, search) => search).reset(signout);

$data
  .on(fxGetList.done, (_, { result }) => {
    if (!Array.isArray(result?.types)) {
      return [];
    }

    return result.types;
  })
  .reset(signout);

$isLoading.on(fxGetList.pending, (_, result) => result).reset(signout);

sample({
  clock: searchChangedDebounce,
  source: $search,
  fn: (search) => ({ search }),
  target: fxGetList,
});
